import {
  IDataPreference,
  IFiltrosDRE
} from "@/features/financas/views/Indicadores/@types/type";
import { AbstractSaveToApi } from "../../Preferencias/types";
import DREStrategy from "./DREStrategy";

export default class SaveDREToApi extends AbstractSaveToApi<IFiltrosDRE> {
  buildPreference(filtro: IFiltrosDRE): IDataPreference<unknown>[] {
    const preferencia = new DREStrategy();

    const preferences: IDataPreference<unknown>[] = [];

    if (filtro.data?.length == 2) {
      preferences.push(
        preferencia.createRangeInicio(filtro.data as string),
        preferencia.createRangeFim(filtro.data as string)
      );
    }

    return [
      preferencia.createCompanies(filtro.empresas as string[]),
      preferencia.createCentroDeCusto(filtro.centrosDeCusto as string[]),
      ...preferences
    ];
  }
}
